module.exports = __webpack_public_path__ + "static/media/icon_diversification2.67c77101.svg";